export default {
	title: 'Výkaz nového dokumentu',
	documentReport: 'Výkaz nového dokumentu',
	subTitle: 'Datum vykázání',
	clientTitle: 'Klient',
	documentTitle: 'Dokument',
	saveAndNext: 'Uložit a další',
	saveAndClose: 'Uložit a zavřít',
	firstName: 'Jméno',
	surname: 'Příjmení',
	businessName: 'Název',
	sellerIn: 'Získatelské číslo',
	personIn: 'Rodné číslo/IČO',
	documentType: 'Typ dokumentu',
	relatedPolicyNo: 'Související PS',
	scannedDocument: 'Sken',
	text: 'Popis',
	businessCaseNo: 'Číslo obchodního případu',
};
